export const dropdownCssClassNames = {
    button: 'Dropdown-button',
    menu: 'Dropdown-menu',
    menuWrapper: 'Dropdown-menuWrapper',
    menuList: 'Dropdown-menuList',
    menuItem: 'Dropdown-menuItem',
    flyout: 'Dropdown-flyout',
    flyoutTitle: 'Dropdown-flyoutTitle',
    flyoutColumns: 'Dropdown-flyoutColumns',
    flyoutColumn: 'Dropdown-flyoutColumn'
};
